import { IStore } from "../types/IStore";

export const pharmacyAdminPharmacies = (state: IStore) => state.pharmacyAdmin.pharmacies;
export const pharmacyAdminProfile = (state: IStore) => state.pharmacyAdmin.pharmacyAdminProfile;